module.exports = __webpack_public_path__ + "img/common-file-text-edit.52409dd5.svg";